import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { useRef, useState, useEffect } from 'react';
import { ANIMATION_STATUS, DEFAULT_ANIMATION_DURATION } from '../../animation.constants';
var PRE_ANIMATING = ANIMATION_STATUS.PRE_ANIMATING,
  ANIMATING = ANIMATION_STATUS.ANIMATING,
  NO_ANIMATION = ANIMATION_STATUS.NO_ANIMATION;
export default function useAnimation() {
  var transitions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$duration = _ref.duration,
    duration = _ref$duration === void 0 ? DEFAULT_ANIMATION_DURATION : _ref$duration;
  var INITIAL_STATE = {
    status: NO_ANIMATION,
    cycle: 0,
    transition: transitions[0]
  };
  var _useState = useState(INITIAL_STATE),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var timeoutId = useRef();
  useEffect(function () {
    return function () {
      return clearTimeout(timeoutId.current);
    };
  }, []);
  function endAnimation() {
    clearTimeout(timeoutId.current);
    setState(INITIAL_STATE);
  }
  function changeStateStatus(newStatus) {
    var nextCycle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (newStatus === NO_ANIMATION && nextCycle) {
      setState(function (previousState) {
        var previousCycle = previousState.cycle;
        var newCycle = previousCycle + 1;
        if (newCycle >= transitions.length) {
          return INITIAL_STATE;
        }
        return {
          status: PRE_ANIMATING,
          cycle: newCycle,
          transition: transitions[newCycle]
        };
      });
    } else {
      setState(function (previousState) {
        return _objectSpread(_objectSpread({}, previousState), {}, {
          status: newStatus
        });
      });
    }
  }
  useEffect(function () {
    var cycle = state.cycle,
      status = state.status;
    if (status === NO_ANIMATION) {
      return;
    }
    if (cycle >= transitions.length) {
      endAnimation();
    }
    if (status === PRE_ANIMATING) {
      timeoutId.current = setTimeout(function () {
        return changeStateStatus(ANIMATING);
      }, 0);
    } else if (status === ANIMATING) {
      timeoutId.current = setTimeout(function () {
        return changeStateStatus(NO_ANIMATION, true);
      }, duration);
    }
  }, [state]);
  function startAnimation() {
    endAnimation();
    timeoutId.current = setTimeout(function () {
      return changeStateStatus(PRE_ANIMATING);
    }, 0);
  }
  return {
    state: state,
    startAnimation: startAnimation,
    endAnimation: endAnimation
  };
}